<script setup lang="ts">
import type { NuxtError } from "#app"
const store = useMainStore()

callOnce(() => store.fetchPages())

defineProps({
    error: Object as () => NuxtError,
})
</script>

<template>
    <div
        class="relative mx-auto h-screen lg:max-w-screen-lg xl:max-w-screen-xl 2xl:max-w-screen-2xl"
    >
        <AppHeader />
        <div
            class="relative inset-0 top-1/4 flex -translate-y-1/2 flex-col items-center justify-center gap-4"
        >
            <svg
                height="200"
                width="200"
            >
                <rect
                    width="150"
                    height="150"
                    style="fill: transparent"
                />
                <circle
                    cx="100"
                    cy="100"
                    r="75"
                    stroke="black"
                    stroke-width="1"
                    fill="none"
                />
                <line
                    x1="75"
                    y1="125"
                    x2="125"
                    y2="75"
                    stroke="black"
                    stroke-width="1"
                />
                <line
                    x1="75"
                    y1="75"
                    x2="125"
                    y2="125"
                    stroke="black"
                    stroke-width="1"
                />
            </svg>
            <div class="page-title mb-0">{{ $t("error.title") }}</div>
            <NuxtLink
                to="/"
                class="text-lg hover:text-hover-link"
                >{{ $t("error.button") }}</NuxtLink
            >
        </div>
    </div>
</template>
